import Grid2 from '@mui/material/Unstable_Grid2';
import { useTranslation } from 'react-i18next';
import { Step } from '../../components/Step';
import MonetizationOnIcon from '@mui/icons-material/MonetizationOn';
import { Checkboxes, TextField } from 'mui-rff';
import { useFormState } from 'react-final-form';
import { required } from 'redux-form-validators';

export const Step3 = () => {
  const { t } = useTranslation('settings');
  const { values } = useFormState();

  return (
    <Step
      title={`${t('integrations.step')} 3`}
      subtitle={t('integrations.if you also want to record')}
      Icon={MonetizationOnIcon}
    >
      <Grid2 xs={12} sx={{ maxWidth: '300px' }} gap={3} container>
        <Grid2 xs={12}>
          <Checkboxes name="recordTransactions" data={{ label: t('integrations.record transactions'), value: true }} />
        </Grid2>
        {values?.recordTransactions && (
          <>
            <Grid2 xs={12}>
              <TextField
                name="idEmpresa"
                label={t('integrations.castilla.company id')}
                fieldProps={{ validate: required() }}
              />
            </Grid2>
            <Grid2 xs={12}>
              <TextField
                name="idConcepto"
                label={t('integrations.castilla.concept id')}
                fieldProps={{ validate: required() }}
              />
            </Grid2>
          </>
        )}
      </Grid2>
    </Step>
  );
};
